let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

if (document.body.clientWidth < 991) {
    const lastCollage = document.querySelector(".faq_content .button");
    const collageSecond = document.querySelector(".faq-section .image-with-text__text-item");
    if (lastCollage && collageSecond) {
        collageSecond.after(lastCollage);
    }
}

//slideshow section 
document.addEventListener('DOMContentLoaded', function () {
  const bulletInterval = setInterval(() => {
    const bullets = document.querySelectorAll('.swiper-pagination-bullet');
    if (bullets.length > 0) {
      bullets.forEach(bullet => {
        // Avoid double appending
        if (!bullet.querySelector('i') && !bullet.querySelector('b')) {
          const iTag = document.createElement('i');
          const bTag = document.createElement('b');
          bullet.appendChild(iTag);
          bullet.appendChild(bTag);
        }
      });
      clearInterval(bulletInterval);
    }
  }, 100);
});

// header menu close icon trigger
document.querySelectorAll('.hender-close').forEach(function(element) {
    element.addEventListener('click', function() {
        document.querySelectorAll('.header__icon.header__icon--menu').forEach(function(menuIcon) {
            menuIcon.click();
        });
    });
});



const swiper = new Swiper(".testimonial-box-wrapper", {
  loop: false,
  speed: 1000,
  navigation: {
    nextEl: ".testimonial-custom-block .swiper-button-next",
    prevEl: ".testimonial-custom-block .swiper-button-prev",
  },
  pagination: {
    el: ".testimonial-box-wrapper .swiper-pagination",
    clickable: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
    },
    350: {
      slidesPerView: 1.2,
      spaceBetween: 10,
      loop: true,
    },
    575: {
      slidesPerView: 2.2,
      spaceBetween: 10,
      loop: true,
    },
    750: {
      slidesPerView: 2.2,
      spaceBetween: 30,
      loop: true,
    },
    992: {
      slidesPerView: 2.5,
      spaceBetween: 30,
      loop: true,
    },
    1200: { slidesPerView: 3.5, spaceBetween: 30 },
  },
});

const contact_swiper = new Swiper(".contact-slider-wrapper", {
  loop: false,
  speed: 1000,
  slidesPerView: 2,
  spaceBetween: 30,
  navigation: {
    nextEl: ".contact-wrapper .swiper-button-next",
    prevEl: ".contact-wrapper .swiper-button-prev",
  }, 
  pagination: {
    el: ".contact-wrapper .swiper-pagination",
    clickable: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 1, spaceBetween: 0 },
    750: { slidesPerView: 2, spaceBetween: 0 },
  },
});

const partner_swiper_block = new Swiper(".partner-block-blocks", {
  loop: true,
  slidesPerView: 4.5,
  speed: 1000, 
  navigation: {
    nextEl: ".partner-block-blocks .swiper-button-next",
    prevEl: ".partner-block-blocks .swiper-button-prev",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 1, spaceBetween: 10 },
    350: { slidesPerView: 2, spaceBetween: 10 },
    575: { slidesPerView: 3, spaceBetween: 10 },
    750: { slidesPerView: 4, spaceBetween: 30 },
    991: { slidesPerView: 4.7, spaceBetween: 30 },
  },
});



const icon_swiper_block = new Swiper(".icon-block-blocks", {
  loop: false,
  slidesPerView: 8,
  centeredSlides: false,
  speed: 1000, 
  navigation: {
    nextEl: ".icon-block-blocks .swiper-button-next",
    prevEl: ".icon-block-blocks .swiper-button-prev",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 1, spaceBetween: 10 },
    350: { slidesPerView: 2, spaceBetween: 10 },
    575: { slidesPerView: 3, spaceBetween: 10 },
    750: { slidesPerView: 4, spaceBetween: 30 },
    991: { slidesPerView: 8, spaceBetween: 22 },
    1100: { slidesPerView: 8, spaceBetween: 32 },
  },
});

if (document.body.clientWidth < 991) {
  const icon_swiper = new Swiper(".text-with-icon-blocks", {
    loop: true,
    speed: 1000,
    pagination: {
      el: ".text-with-icon-blocks .swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".text-with-icon-blocks .swiper-button-next",
      prevEl: ".text-with-icon-blocks .swiper-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    effect: "slide",
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 20 },
      350: { slidesPerView: 1.5, spaceBetween: 20, centeredSlides: true },
      575: { slidesPerView: 2.3, spaceBetween: 20, centeredSlides: true },
      768: { slidesPerView: 2.5, spaceBetween: 20, centeredSlides: true },
      990: { slidesPerView: 2.5, spaceBetween: 20, centeredSlides: true },
    },
  });

  const service_icon_swiper = new Swiper(".service-icon-blocks", {
    loop: true,
    speed: 1000,
    scrollbar: {
      el: ".service-icon-blocks .swiper-pagination",
      hide: false,
      draggable: true
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".service-icon-blocks .swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".service-icon-blocks .swiper-button-next",
      prevEl: ".service-icon-blocks .swiper-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    effect: "slide",
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 0, centeredSlides: true },
      400: { slidesPerView: 1, spaceBetween: 0, centeredSlides: true },
      575: { slidesPerView: 2, spaceBetween: 10 },
      768: { slidesPerView: 2, spaceBetween: 10 },
      990: { slidesPerView: 2, spaceBetween: 10 },
    },
  });
}

if (document.body.clientWidth < 750) {
  const colgroup_swiper = new Swiper(".colgroup-wrap", {
    loop: false,
    slidesPerView: 3,
    speed: 1000,
    navigation: {
      nextEl: ".colgroup-wrap .swiper-button-next",
      prevEl: ".colgroup-wrap .swiper-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    effect: "slide",
    breakpoints: {
      0: { slidesPerView: 2, spaceBetween: 20 },
      350: { slidesPerView: 3, spaceBetween: 20 },
      575: { slidesPerView: 3, spaceBetween: 20 },
      750: { slidesPerView: 3, spaceBetween: 20 },
    },
  });
 
}

//footer accordian
// accordions js start
function nav_taggol() {
  const accordionss = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    tab_content.style.maxHeight = tab_content.scrollHeight + "px";
  };
  
  const closeAccordion = (accordion) => {
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(tab_content){
      tab_content.style.maxHeight = null;
    }
  };

  accordionss.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    if(intro && tab_content){
        intro.onclick = (e) => {
          if (tab_content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordionss.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });
}
nav_taggol();


// ====== faq page accordian  ======
document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        if (!localStorage.getItem("firstLoad")) {
            const modal = document.querySelector(".custom-model-main");
            if (modal) {
                modal.classList.add("model-open");
                localStorage.setItem("firstLoad", "true");
            }
        }
    }, 3000);

    document.querySelectorAll(".close-btn, .bg-overlay").forEach(function (element) {
        element.addEventListener("click", function () {
            const modal = document.querySelector(".custom-model-main");
            if (modal) {
                modal.classList.remove("model-open");
            }
        });
    });

    if (document.body.clientWidth < 991) {
        const lastCollage = document.querySelector(".last_collage.image_banner_collage_item");
        const collageSecond = document.querySelector(".collage_second.image_banner_collage_item");
        if (lastCollage && collageSecond) {
            collageSecond.after(lastCollage);
        }
    }

    if (document.body.clientWidth < 750) {
        const imageMedia = document.querySelector(".about-image-text-bg.image-with-text__media-item");
        const imageText = document.querySelector(".about-image-text-bg.image-with-text__text-item");
        if (imageMedia && imageText) {
            imageText.after(imageMedia);
        }
    }

    document.querySelectorAll(".faq_accordion .accordion").forEach(function (accordion) {
        accordion.addEventListener("click", function () {
            const isOpen = accordion.classList.contains("is-open");
            document.querySelectorAll(".faq_accordion .accordion").forEach(function (item) {
                item.classList.remove("is-open");
                const content = item.nextElementSibling;
                if (content) content.style.maxHeight = "0px";
            });
            if (!isOpen) {
                accordion.classList.add("is-open");
                const content = accordion.nextElementSibling;
                if (content) content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });

    document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (accordion) {
        accordion.addEventListener("click", function () {
            const isOpen = accordion.classList.contains("is-open");
            document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (item) {
                item.classList.remove("is-open");
                const content = item.nextElementSibling;
                if (content) content.style.maxHeight = "0px";
            });
            if (!isOpen) {
                accordion.classList.add("is-open");
                const content = accordion.nextElementSibling;
                if (content) content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });
});

// -------------- faq page  js
const faqtitle = document.querySelectorAll('.faq-btn');

faqtitle.forEach(faqtitles => {
  faqtitles.addEventListener('click', function (event) {
    event.preventDefault();

    const gettitle = this.getAttribute('data-btn-title');
    console.log(gettitle, "gettitle");
    faqtitle.forEach(btn => btn.classList.remove('active')); // Remove from all buttons
    this.classList.add('active');


    document.querySelectorAll('.faq-page-content').forEach(content => {
      content.style.display = "none";
    });

    const contentdiv = document.querySelector(`.faq-page-content[data-faq-content="${gettitle}"]`);
    console.log(contentdiv, 'contentdiv');

    if (contentdiv) {
      contentdiv.style.display = "block";
    }
   const classremove  =  document.querySelector('.dropdown-content');
    classremove.classList.remove('dropdown-active')
  });
});

document.querySelectorAll('.dropdown-button').forEach(dropdownBtn => {
  dropdownBtn.addEventListener('click', function (event) {
    event.stopPropagation(); // Prevents immediate closing when clicking button

    const closestDiv = this.closest('.dropdown');
    const dropdownContent = closestDiv.querySelector('.dropdown-content');

    // Close all other dropdowns
    document.querySelectorAll('.dropdown-content').forEach(content => {
      if (content !== dropdownContent) {
        content.classList.remove('dropdown-active');
      }
    });

    dropdownContent.classList.toggle('dropdown-active');
  });
});

document.addEventListener('click', function (event) {
  document.querySelectorAll('.dropdown-content').forEach(content => {
    if (!content.closest('.dropdown').contains(event.target)) {
      content.classList.remove('dropdown-active');
    }
  });
});


// ACC tabs toggal start
function togal_tabs (item) {
  if(item.classList.contains('is_select')) return;
  item.classList.add('is_select');
  item.addEventListener("click", () => {
     toggal_all_tabs(item.getAttribute('data-faq_content'));
  });        
}

function toggal_all_tabs(tabs_data){
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach(b => {
    if(b.getAttribute('data-faq_content') == tabs_data){
      if(b.classList.contains('is_open')){ 
         b.classList.remove("is_open");    
        }else{
        console.log("iiiiiiiiiiiiii")
         b.classList.add("is_open");
        }
    }else{
       b.classList.remove("is_open");
    }
  });             
}
function faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
  tabs_title.forEach(togal_tabs);
}
faq_taggol();
// ACC tabs toggal end




// i click on btn change price 1.19/
function updatePrice() {
    var priceElements = document.querySelectorAll('.price-item');
    var price, updatedPrice;
    const priceText1 = document.querySelector('.product__tax.caption.rte:not(.update-price-text)');
    const priceText2 = document.querySelector('.update-price-text');

    // Read value from localStorage
    const isOnChecked = localStorage.getItem('on-checked') === 'true';

    priceElements.forEach(function (elem) {
        let rawPrice = elem.getAttribute('data-price');
        if (!rawPrice) return;

        price = parseFloat(rawPrice.replace(/\./g, '').replace(',', '.'));
        if (isNaN(price)) return;

        if (isOnChecked) {
            updatedPrice = price / 1.19;
            priceText1 && (priceText1.style.display = 'none');
            priceText2 && (priceText2.style.display = 'block');
        } else {
            updatedPrice = price;
            priceText1 && (priceText1.style.display = 'block');
            priceText2 && (priceText2.style.display = 'none');
        }

        updatedPrice = updatedPrice.toFixed(2);

        var formattedPrice = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(updatedPrice);

        elem.innerText = formattedPrice;
    });
}

// ✅ Listen for changes on #on and #off
document.getElementById('on')?.addEventListener('change', function () {
    localStorage.setItem('on-checked', this.checked ? 'true' : 'false');
    updatePrice();
});

document.getElementById('off')?.addEventListener('change', function () {
    localStorage.setItem('on-checked', 'false');
    updatePrice();
});

// ✅ On page load: initialize state and apply prices
document.addEventListener('DOMContentLoaded', function () {
    localStorage.removeItem('on-checked'); // 👈 clear saved state
    const checkbox = document.getElementById('on');
    if (checkbox) checkbox.checked = false; // 👈 uncheck it on load
    updatePrice(); // 👈 apply regular taxed price
});


// inquiry form btn popup on product page 

document.addEventListener("DOMContentLoaded", function () {
    const formBtn = document.querySelector(".form-btn");
    const popup = document.querySelector(".contant-form-popup");

    if (formBtn && popup) {
        formBtn.addEventListener("click", function () {
            document.body.classList.add("open-popup");
            popup.classList.add("open-popup");
        });

        document.addEventListener("click", function (event) {
            if (!event.target.closest(".contant-form-popup") && !event.target.closest(".form-btn")) {
                document.body.classList.remove("open-popup");
                popup.classList.remove("open-popup");
            }
        });
    }
});



// contact form  popup on product page 


 document.addEventListener("DOMContentLoaded", function () {
  const bodyClass = document.querySelector(".template-product");
  const formBtn = document.querySelector(".form-btn-inquery");
  const closeBtn = document.querySelector(".close-btn");
  const popupOverlay = document.querySelector(".form_overlay_popup");

  if (formBtn && popupOverlay) {
    // Open popup
    formBtn.addEventListener("click", function () {
      popupOverlay.style.display = "block";
      bodyClass.classList.add("open-popup");
    });
  }

  if (closeBtn && popupOverlay) {
    // Close popup
    closeBtn.addEventListener("click", function () {
      popupOverlay.style.display = "none";
      bodyClass.classList.remove("open-popup");
    });
  }
});

//  custom bundal code end
function custom_addtocart_fun(product,open_drawer){
  console.log("product",product);
      fetch(`${routes.cart_add_url}`,{ 
              method: 'POST',
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: JSON.stringify(product)
        })
        .then(response => response.json()).then(response => {     
          console.log(response);   
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally((e) => {
          // console.log("finally");
          if(open_drawer){
            const this_cartDrawer = document.querySelector('cart-drawer');
           // console.log("this_cartDrawer",this_cartDrawer);
            this_cartDrawer.refresh(true);
          }
        });
    }

// timestep using remove item
function removeBundleItemsByTimestamp(timestamp) {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const updates = {};

      cart.items.forEach((item) => {
        const itemTimestamp = item.properties?._timestamp;
        if (itemTimestamp && itemTimestamp.toString() === timestamp.toString()) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length > 0) {
        custom_updatecart(updates, true); // ✅ Correct method to remove items
      } else {
        console.warn('No matching bundle items found for timestamp:', timestamp);
      }
    })
    .catch((err) => console.error('Failed to fetch cart:', err));
}

function custom_updatecart(updates, open_drawer = true) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
    .then(res => res.json())
    .then(cart => {
      console.log('Bundle items removed. Updated cart:', cart);

      if (open_drawer) {
        const this_cartDrawer = document.querySelector('cart-drawer');
        if (this_cartDrawer && typeof this_cartDrawer.refresh === 'function') {
          this_cartDrawer.refresh(true);
        } else {
          console.warn('Cart drawer not found or refresh method missing');
        }
      }
    })
    .catch(err => {
      console.error('Error removing items from cart:', err);
    });
}

//without variant upsell product hide show logic 

 document.addEventListener("DOMContentLoaded", function () {
      const dropdown = document.getElementById("upsellTitleDropdown");
      const slides = document.querySelectorAll(".upsell-slide-main");

      function filterSlidesByTitle(selectedTitle) {
        slides.forEach(slide => {
          const titles = (slide.getAttribute("data-title") || "").toLowerCase().split(',');
          const match = titles.includes(selectedTitle.toLowerCase());
          slide.style.display = match ? "block" : "none";
        });

        if (typeof Swiper !== "undefined" && window.upsellSwiper) {
          window.upsellSwiper.update(); // optional: update swiper if you store instance
        }
      }

      if (dropdown && slides.length > 0) {
        filterSlidesByTitle(dropdown.value); // initial filter on load
        dropdown.addEventListener("change", function () {
          filterSlidesByTitle(this.value);
            const pdpSliders = document.querySelectorAll('[data-pdp-slider-variant]');

          if (pdpSliders.length > 0) {
            pdpSliders.forEach((sliderEl) => {
              const slider = sliderEl.swiper; // Swiper instance attached to the element
          
              if (slider && slider.slides && slider.slides.length > 0) {
                slider.slideTo(0, 0, false); // Jump to the first slide (no animation)
              }
            });
          }


        });
      }
    });


// update all price on the click swich btn 

document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.getElementById('on-price');
  const toggleInput = document.getElementById('on');
  const toggleSwitch = document.querySelector('.toggle-switch');
  const taxMultiplier = 1.19;

  if (!checkbox) return;

  function formatMoney(cents) {
    const amount = cents / 100;
    return amount.toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    });
  }

  function updatePrices(isNet) {
    const jsonScripts = document.querySelectorAll('[data-selected-variant]');
    jsonScripts.forEach(script => {
      const productContainer = script.closest('.card-wrapper, .grid__item');
      console.log("productContainer",productContainer);
      const salePriceEl = productContainer?.querySelector('.price__sale .price-item--sale');
      const comparePriceEl = productContainer?.querySelector('.price__sale s[data-price]');
      const regularPriceEl = productContainer?.querySelector('.price__regular .price-item--regular[data-price]');

      let variantData;
      try {
        variantData = JSON.parse(script.textContent || '{}');
      } catch (e) {
        console.warn('Invalid JSON in one product');
        return;
      }

      const baseSale = salePriceEl?.dataset.price?.replace(/[^\d]/g, '');
      const baseCompare = comparePriceEl?.dataset.price?.replace(/[^\d]/g, '');
      const baseRegular = regularPriceEl?.dataset.price?.replace(/[^\d]/g, '');
   //   console.log("baseRegular",baseRegular);
      if (isNet) {
        if (baseCompare && salePriceEl && comparePriceEl) {
          salePriceEl.textContent = formatMoney(parseInt(baseSale) / taxMultiplier);
          comparePriceEl.textContent = formatMoney(parseInt(baseCompare) / taxMultiplier);
        } else if (baseRegular && regularPriceEl) {
          regularPriceEl.textContent = formatMoney(parseInt(baseRegular) / taxMultiplier);
        }
      } else {
        if (baseCompare && salePriceEl && comparePriceEl) {
          salePriceEl.textContent = formatMoney(parseInt(baseSale));
          comparePriceEl.textContent = formatMoney(parseInt(baseCompare));
        } else if (baseRegular && regularPriceEl) {
          regularPriceEl.textContent = formatMoney(parseInt(baseRegular));
        }
      }
    });
  }
  // Listen for checkbox change
  checkbox.addEventListener('change', function () {
    const isChecked = this.checked;

    // Update localStorage
    localStorage.setItem('on-price-checked', isChecked ? 'true' : 'false');

    // Update prices
    updatePrices(isChecked);

    // Trigger toggle input
    if (toggleInput) {
      toggleInput.click();
    }
  });

 // On page load, restore checkbox state from localStorage
  const savedState = localStorage.getItem('on-price-checked');
  if (savedState === 'true') {
    checkbox.checked = true;
    updatePrices(true);
  
    setTimeout(() => {
      if (toggleInput) toggleInput.click();
    }, 100); // adjust delay if needed
  }
    if (toggleSwitch?.classList.contains('a')) {
    setTimeout(() => {
      if (toggleInput) toggleInput.click();
    }, 100); 
  }
});

